import { render, staticRenderFns } from "./allStudents.vue?vue&type=template&id=cee56aac&"
import script from "./allStudents.vue?vue&type=script&lang=js&"
export * from "./allStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports